// Setup Stripe.js and the Elements provider
import railsFetch from "../railsFetch";
import { loadStripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";
import { Form } from "./Form";
import React from "react";

export const CheckoutForm = (props) => {
  const stripePromise = loadStripe(props.stripeKey);

  return (
    <Elements stripe={stripePromise} options={{ locale: props.locale }}>
      <Form
        outstandingBalance={props.outstandingBalance}
        i18n={props.i18n}
        walletPayment={props.walletPayment}
        klarnaPayment={props.klarnaPayment}
        onSubmitPayment={(body) => submitPayment(body, props.paymentUrl)}
      />
    </Elements>
  );
};

// POST the payment method / confirmed intent to the backend (GR-1188).
async function submitPayment(body, url) {
  const response = await railsFetch(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
    },
    body: JSON.stringify(body),
  });

  try {
    return await response.json();
  } catch {
    // Non-JSON response (e.g. an HTML 500) — let the form show an error.
    return {};
  }
}
